import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PersonalDataFormGroup } from '@app/models/form.models';
import { ValidatedDatePickerComponent } from '@app/ui-components/validated-date-picker/validated-date-picker.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { GetLocalizedPipe } from 'src/app/+pipes/get-localized.pipe';
import { GenericStore } from 'src/app/+store/generic.store';

@Component({
  selector: 'app-profile-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    GetLocalizedPipe,
    ValidatedDropdownComponent,
    ValidatedInputComponent,
    ValidatedDatePickerComponent,
  ],
  templateUrl: './profile-edit.component.html',
  styleUrl: './profile-edit.component.scss',
})
export class ProfileEditComponent {
  public store = inject(GenericStore);
  @Input({ required: true }) formGroup!: FormGroup<PersonalDataFormGroup>;
}
